const router = function (permissions) {
  return ({
    path: 'cdc/servicos',
    component: () => import('@/views/Servico/ServicoModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        meta: { permissions, title: 'Manutenção de Serviços' },
        component: () => import('@/views/Servico/ServicoList.vue'),
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/Servico/ServicoProfile.vue'),
        meta: { permissions, title: 'Cadastrando Serviço' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/Servico/ServicoProfile.vue'),
        meta: { permissions, title: 'Editando Serviço' },
      },
    ],
  })
}

export default {
  router,
}
